import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import {TextField, Tooltip, IconButton, Grid} from '@material-ui/core';
import {Add as AddIcon} from '@material-ui/icons';
import {getIntegerChangeHandler} from '@ozgene/gp5.utils.data-functions';
import ConsumableUpdateCreateDialog from 'Consumables/views/UpdateCreateConsumableDialog';
import MetricUnitUpdateCreateDialog from 'Consumables/views/UpdateCreateMetricUnitDialog';
import {useStyles} from 'Utility/styles';
import SelectMetricUnit from 'Consumables/components/SelectMetricUnit';
import SelectConsumable from 'Consumables/components/SelectConsumable';

export default function StepConsumableEditor(props) {
  const classes = useStyles();
  const {entity, onPropertyChange, onValidityChange} = props;
  const {consumable, metricUnit, quantity = ''} = entity;
  const [consumableDialogOpen, setConsumableDialogOpen] = useState(false);
  const [metricUnitDialogOpen, setMetricUnitDialogOpen] = useState(false);
  const handleCloseConsumableDialog = () => {
    setConsumableDialogOpen(false);
  };
  const handleCloseMetricUnitDialog = () => {
    setMetricUnitDialogOpen(false);
  };
  const handleOpenConsumableDialog = () => setConsumableDialogOpen(true);
  const handleOpenMetricUnitDialog = () => setMetricUnitDialogOpen(true);
  const handleChangeConsumable = (consumable) => onPropertyChange({consumable});
  const handleChangeQuantity = getIntegerChangeHandler(
    'quantity',
    onPropertyChange,
  );
  const handleChangeMetricUnit = (metricUnit) => onPropertyChange({metricUnit});

  useEffect(
    () => onValidityChange(consumable && metricUnit && quantity > 0),
    [consumable, metricUnit, quantity, onValidityChange],
  );

  return (
    <>
      {consumableDialogOpen && (
        <ConsumableUpdateCreateDialog
          closeDialog={handleCloseConsumableDialog}
        />
      )}
      {metricUnitDialogOpen && (
        <MetricUnitUpdateCreateDialog
          closeDialog={handleCloseMetricUnitDialog}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={10}>
          <SelectConsumable
            fullWidth
            onChange={handleChangeConsumable}
            value={consumable}
            error={!consumable}
            errorText={!consumable ? 'Consumable is required' : ''}
          />
        </Grid>
        <Grid item xs={2}>
          <Tooltip title="Add Consumable">
            <IconButton
              onClick={handleOpenConsumableDialog}
              className={classes.iconButton}
              color="primary"
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Grid>
        <Grid item md={5}>
          <TextField
            value={quantity}
            onChange={handleChangeQuantity}
            label="Quantity"
            fullWidth
            type="number"
            inputProps={{maxLength: 11}}
            error={!quantity}
            helperText={!quantity ? 'Quantity is required' : ''}
          />
        </Grid>
        <Grid item md={10}>
          <SelectMetricUnit
            value={metricUnit}
            onChange={handleChangeMetricUnit}
            required
            error={!metricUnit}
            errorText={!metricUnit ? 'Metric unit is required' : ''}
          />
        </Grid>
        <Grid item md={2}>
          {/* button to add metric unit on the go */}
          <Tooltip title="Add Metric Unit">
            <IconButton
              onClick={handleOpenMetricUnitDialog}
              className={classes.iconButton}
              color="primary"
            >
              <AddIcon />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    </>
  );
}

StepConsumableEditor.propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string,
    consumable: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      productCode: PropTypes.string,
      supplier: PropTypes.string,
    }),
    metricUnit: PropTypes.shape({
      id: PropTypes.string,
      unit: PropTypes.string,
    }),
    quantity: PropTypes.number,
  }),
  onPropertyChange: PropTypes.func.isRequired,
  onValidityChange: PropTypes.func.isRequired,
};

StepConsumableEditor.defaultProps = {
  entity: {
    consumable: null,
    metricUnit: null,
    quantity: 0,
  },
};
